import Header from "../Header";
import styles from "./Products.module.css";
import ProductTable from "./ProductTable";

const Products = () => {
  return (
    <div className={`${styles.fontFamily} h-screen py-4 pr-4`}>
      <div className="p-4 rounded-3xl h-full bg-[#ffeded]">
        <div className="flex flex-col justify-between h-full">
          <Header title={"Products"} />
          <div className={`w-full h-full rounded-2xl m-2 px-2`}>
            <ProductTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
